<template>
  <div
    class="counselor lav-cards__card-wrapper circular-image"
    data-slider-item
    :class="{ 'show-grid-label': showGridLabel }"
  >
    <div class="lav-card__container">
      <span
        class="lav-card__grid-label"
        v-if="showGridLabel"
        v-text="gridLabelText"
      />
      <div class="lav-card__text">
        <div class="lav-card__text-first">
          <counselor-card-image
            :counselor="counselor"
            :is-therapist="isTherapist"
            :link="link"
            :use-circular-image="true"
          />
          <p class="lav-card__name">
            <a :href="link" v-text="counselor.name" />
          </p>
          <button class="counselor-card__verified" @click="toggleVerifiedModal">
            <svg aria-hidden="true" class="icon" viewBox="0 0 21 21">
              <use href="#verified" />
            </svg>
            <span
              class="counselor-card__verified-text"
              v-text="verifiedText.verified"
            />
          </button>
          <p class="counselor-card__title" v-text="counselor.title" />
          <rating-stars
            class="counselor-card__rating"
            show-rating-text
            v-if="counselor.rating > 0"
            :link="link"
            :number-of-reviews="counselor.number_of_reviews"
            :rating="parseFloat(counselor.rating)"
          />
          <div
            class="counselor-card__competence"
            v-if="isTherapist || showCompetenceAreas"
          >
            <competence-area-pills
              v-if="showCompetenceAreas"
              :competence-areas="competenceAreas"
              :filtered-competences="filteredCompetences"
            />
          </div>
          <p
            class="counselor-card__languages"
            v-if="isArchive && isTherapist && counselor.languages"
            v-html="languagesString"
          />
        </div>
        <div class="lav-card__text-second">
          <counselor-card-meeting-types
            :counselor="counselor"
            :filtered-meeting-types="filteredMeetingTypes"
            :is-archive="isArchive"
            :is-lawyer="isLawyer"
            :is-therapist="isTherapist"
          />
          <counselor-card-availability-slots
            :counselor="counselor"
            :filtered-competences="filteredCompetences"
            :link="link"
            :schedule="schedule"
          />
          <counselor-card-cta
            :counselor="counselor"
            :is-therapist="isTherapist"
            :link="link"
            :show-phone-number="showPhoneNumber"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompetenceAreaPills from 'Main/components/CompetenceAreaPills.vue';
import BaseCounselorCard from 'Main/components/counselor-card/BaseCounselorCard.vue';
import CounselorCardAvailabilitySlots from 'Main/components/counselor-card/components/availability-slots/CounselorCardAvailabilitySlots.vue';
import CounselorCardImage from 'Main/components/counselor-card/components/CounselorCardImage.vue';
import CounselorCardMeetingTypes from 'Main/components/counselor-card/components/CounselorCardMeetingTypes.vue';
import CounselorCardCta from 'Main/components/counselor-card/components/cta/CounselorCardCta.vue';
import RatingStars from 'Main/components/RatingStars.vue';
import { verifiedCategoryForRole } from 'Main/verified-by-lavendla/helpers';

export default {

  components: {
    CompetenceAreaPills,
    CounselorCardAvailabilitySlots,
    CounselorCardCta,
    CounselorCardImage,
    CounselorCardMeetingTypes,
    RatingStars,
  },

  computed: {

    gridLabelText() {
      if (this.counselor.returning_customer) {
        return this.counselor.returning_customer;
      }

      return this.counselor.booked_in_the_latest_72_hours;
    },
    showGridLabel() {
      return this.gridLabelText && (this.isLawyer || this.isTherapist);
    },
  },

  data() {
    return {
      counselorContactTexts: theme_vars.counselorContactFormTexts,
      currentSite: theme_vars.currentSite,
      currentSiteId: theme_vars.currentSiteId,
      texts: theme_vars.counselorSlider,
      verifiedText: theme_vars.verified,
    };
  },

  extends: BaseCounselorCard,

  methods: {
    toggleVerifiedModal() {
      this.$store.dispatch(
        'verifiedByLavendla/toggleModal',
        verifiedCategoryForRole(this.role)
      );
    },
  },
  name: 'CounselorCardRoundImage',

  props: {
    counselor: {
      required: true,
      type: Object,
    },
    isArchive: {
      default: false,
      type: Boolean,
    },
    isLawyer: {
      default: false,
      type: Boolean,
    },
    isTherapist: {
      default: false,
      type: Boolean,
    },
    role: {
      default: '',
      type: String,
    },
    schedule: {
      required: true,
      type: Array,
    },
    showCompetenceAreas: {
      default: false,
      type: Boolean,
    },
    showPhoneNumber: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
